import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectIsAuthenticated } from '../store/selectors.js';
import { buildSignInRedirect } from '../lib/authRedirect.js';

export function RequireAuth({ children }) {
  const isAuthed = useSelector(selectIsAuthenticated);
  const location = useLocation();
  if (!isAuthed) {
    return <Navigate to={buildSignInRedirect(location)} replace state={{ from: location }} />;
  }
  return children;
}
